import store from "@/store"

export default {
  path: 'users',
  component: () => import(/* webpackChunkName: "admin" */ '@/components/wrapper.vue'),
  beforeEnter: function (to, from, next) {
    store.dispatch('users.get').then(() => next())
  },
  children: [
    {
      path: '/',
      name: 'admin.users',
      component: () => import(/* webpackChunkName: "admin" */ './userList.vue'),
    }, {
      path: ':userId',
      name: 'admin.user.view',
      component: () => import(/* webpackChunkName: "admin" */ '@/app/user/profile.vue'),
    },
    {
      path: 'add',
      name: 'admin.user.add',
      component: () => import(/* webpackChunkName: "admin" */ './addUser.vue'),
    }
  ],
}
